export type FetchResponse = any;
export type ResponseSingle<T> = {
  data: T;
};
export type ResponseMulti<T> = {
  data: {
    content: T[];
    page: ContentPage;
  };
};

export interface ContentPage {
  number: number;
  size: number;
  total_elements: number;
  total_pages: number;
}
/**
 * @deprecated BE does not actively support this type
 */
export interface Link {
  rel?: string;
  href?: string;
  title?: string;
  type?: string;
}
export enum SegmentTag {
  PERSONALCARE = 'PERSONALCARE',
  HOMECARE = 'HOMECARE',
  FOOD = 'FOOD'
}
export enum SegmentTagLabel {
  PERSONALCARE = 'Personal care',
  HOMECARE = 'Home care'
}

export interface SelectedRowIds {
  [x: number]: boolean;
}

export interface Option {
  value: any;
  label: string;
  context?: string;
}

export interface AdvancedTableRow<T> {
  row: {
    original: T;
  };
  [x: string]: any;
}

export interface Award {
  event: string;
  year: string;
  category: string;
  title: string;
  awarded: boolean;
  link: string;
  verified: boolean;
  created_at: string;
  created_by: string;
}
export interface AwardInProduct extends Award {
  awarded: boolean;
  category_key: string;
  category_name: string;
  created_at: string;
  created_by: string;
  event_key: string;
  event_name: string;
  level: AwardLevel;
  link: string;
  verified: boolean;
  year: string;
}

export enum AwardLevel {
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD'
}
